import { CollectionsErrorCode } from '../../../ts/helpers/ErrorCodes';
import { IContentInfo } from '../../../ts/models/IContentInfo';

// Model is returned from API and ICollectionInfo is item VPC uses.
export enum CollectionVisibility {
  private = 'private',
  public = 'public'
}
export interface Collection {
  readonly id: string;
  readonly luid: string;
  readonly name: string;
  readonly description: string;
  readonly visibility: CollectionVisibility;
  readonly totalItemCount: number;
  readonly permissionedItemCount: number;
  readonly userId: string;
  readonly createdTime: string;
  readonly updatedTime: string;
  readonly favorite: boolean;
}

export interface CollectionItem {
  readonly collectionLuid: string;
  readonly contentId: string;
  readonly contentLuid: string;
  readonly name: string;
  readonly position: string;
  readonly contentType: string;
  readonly content: any;
}

export interface CollectionContentItem extends IContentInfo {
  readonly collectionLuid: string;
  readonly position: string;
}

export interface DeleteCollectionData {
  readonly successfulLuids: string[];
  readonly errors: CollectionError[];
}

export interface AddRemoveCollectionItemsData {
  readonly numItemsSuccessfullyUpdated: number;
  readonly errors: CollectionError[];
  readonly collectionLuid: string;
}

export interface AddRemoveCollectionItem {
  readonly contentLuid: string;
  readonly contentName: string;
  readonly contentType: string;
}

export interface UpdateCollectionsResponseData {
  readonly successfulLuids: string[];
  readonly errors: CollectionError[];
}

export interface CollectionError {
  readonly errorCode: CollectionsErrorCode;
  readonly errorMessage: string;
  readonly erroredItem: CollectionErroredItem;
  readonly luid: string;
}

export interface CollectionErroredItem {
  readonly contentLuid: string;
  readonly contentName: string;
  readonly contentType: string;
}
